import * as React from 'react';
import CommonUtils from '@/utils/commonUtils';
class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      data: null, // 具体要显示的内容
      pmid_text: null, // 签名
      content_pair_list: [],
    };
  }
  UNSAFE_componentWillMount() {
    //  console.log('this.props.content', this.props.content);
    if (this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.content !== this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }

  // 查找要显示的内容
  findData = () => {
    let content = this.state.content;
    console.log('content: ', content);
    if (content && content.length > 0) {
      let pair_list = [];
      for(let i=0,len=content.length; i<len; i++){
        let content_pair = {
          abs: null,
          pmid_text: null,
        };
        let ele_pair = content[i] instanceof Array ? content[i] : content;
        let find = ele_pair.find(v => { return v.label === 'abs_ele' });
        if (find && find.content && find.content.length > 0) {
          let find2 = find.content.find(y => { return y.label === 'abs_text' });
          if (find2) {
            content_pair.abs = find2.content;
          }
        }
        let pmid_ele = ele_pair.find(v => { return v.label === 'pmid_ele' });
        if (pmid_ele && pmid_ele.content && pmid_ele.content.length > 0) {
          let find2 = pmid_ele.content.find(y => { return y.label === 'pmid_text' });
          if (find2) {
            content_pair.pmid_text = find2.content;
            };
          }
        pair_list.push(content_pair);
        }
      console.log('pair_list', pair_list);
      this.setState({content_pair_list: pair_list});
    }
  }

  render() {
    return (
      <React.Fragment>
        {
          this.state.content_pair_list.map((content_pair, index) =>(
            <div key={index}>
              <div
                style={{ fontSize: "0.16rem", lineHeight: "0.32rem", textAlign: 'justify', textIndent: '0.35rem' }}
                dangerouslySetInnerHTML={{ __html: CommonUtils.wordDictReplaceStr(content_pair.abs) }}
              />
              <div style={{ marginTop: '0.1rem', marginBottom: '0.75rem', textAlign: 'right' }}>-- {content_pair.pmid_text}</div>
            </div>
          ))
        }
      </React.Fragment>
    );
  }

}

export default Summary;